import { useNavigate } from 'react-router-dom';
import styles from '../styles/Datalist.module.css';

const ClientSearchListItem = ({clientInfo,clickActionCallback}) => {
    let statusClass;
    let statusText;
    switch(clientInfo.applicationstatus){
        case "NOT STARTED":
            statusClass = "badge bg-secondary d-inline";
            statusText = clientInfo.applicationstatus;
            break;
        case "Transitioned":
            statusClass = "badge bg-success d-inline";
            statusText = clientInfo.applicationstatus;
            break;
        case "Denial":
            statusClass = "badge bg-danger d-inline";
            statusText = clientInfo.applicationstatus;
            break;
        default:
            statusClass = "badge bg-warning d-inline";
            statusText = "IN PROGRESS";
    }

    const navigate = useNavigate();
    const firstName = clientInfo.firstname ?? clientInfo.fName ?? "";
    const lastName = clientInfo.lastname ?? clientInfo.lName ?? "";
    const handleClick = () => {
        if(clickActionCallback){
            clickActionCallback(clientInfo);
            return;
        }

        navigate(`/Client/Client/${clientInfo.medicaididenc}`);
    };

    return(
        <button className={`${styles["data-card"]} ${styles["fiveCol"]} ${styles["colMark"]} mb-3`} onClick={handleClick} type='button' aria-label={`Open client record for ${lastName}, ${firstName}`}>
            <span className={styles["datapoint"]}>
                {
                    clientInfo.applicationid
                    ?
                        <>
                            <span className={styles["datalabel"]}>
                                Application ID
                            </span>
                            <span className={styles["datacol"]}>
                                {clientInfo.applicationid}
                            </span>
                        </>
                    :
                        <>
                            <span className={styles["datalabel"]}>
                                Medicaid ID
                            </span>
                            <span className={styles["datacol"]}>
                                {clientInfo.medicaidid}
                            </span>
                        </>
                }
            </span>
            <span className={styles["datapoint"]}>
                <span className={styles["datalabel"]}>
                    First Name
                </span>
                <span className={styles["datacol"]}>
                    {firstName}
                </span>
            </span>
            <span className={styles["datapoint"]}>
                <span className={styles["datalabel"]}>
                    Last Name
                </span>
                <span className={styles["datacol"]}>
                    {lastName}
                </span>
            </span>
            <span className={styles["datapoint"]}>
                <span className={styles["datalabel"]}>
                    Date Added
                </span>
                <span className={styles["datacol"]}>
                    {clientInfo.dateadded}
                </span>
            </span>
            <span className={styles["datapoint"]}>
                <span className={styles["datalabel"]}>
                    Application Status
                </span>
                <span className={`${styles["finalcol"]} ${styles["datacol"]}`}>
                    <span className={statusClass}>{statusText.toUpperCase()}</span>
                </span>
            </span>
        </button>
    )
}

export default ClientSearchListItem;
